module.exports = __webpack_public_path__ + "img/ppt-icon.16a5dfe.png";